import { atom } from "recoil";

export const ScheduleTimelineReloadState = atom<boolean>({
  key: "scheduleTimelineReloadState ",
  default: false,
});
